module.exports = __webpack_public_path__ + "static/media/home2icons1.a9445c51.svg";